import { TableSortingChangeHandler, TableSortingOrder } from 'ui/components/Table'

import { ContactDetailsRequest, ContactDetailsResponse } from '../../../../types'

export interface ContactDetailsPageProps {
  isFetching: boolean
  data: ContactDetailsResponse
  invalidate: () => void
  historyTableConfig: {
    isFetching: boolean
    filter: {
      page?: number
      size?: number
    }
    onFilterChange: (page: number, size: number) => void
  }

  documentsTableConfig: {
    isFetching: boolean
    onFilterChange: (filter: ContactDetailsRequest) => void
    order: TableSortingOrder[]
    onOrderChange: TableSortingChangeHandler
  }
}
